<template>
  <v-flex>
    <div class="p-t-20">
      <div class="tituloBox border-top">
        <div class="bg-red barraTitulo"></div>
        <h1 class="text-default font-size-14">
          <strong>Dirigentes</strong>
        </h1>
      </div>
    </div>
    <div class="clear"></div>
    <v-data-table
      :headers="headers"
      :items="habilitacaoLista.dirigentesLista"
      :loading="loading"
      :hide-actions="true"
      class="elevation-1 tableAprovarRejeitar"
    >
      <template slot="items" slot-scope="props">
        <tr
          v-bind:class="{'item-aprovado':(props.item.habilitacaoJuridicaSituacao==2),'item-reprovado':(props.item.habilitacaoJuridicaSituacao==1)}"
        >
          <td class="text-center" nowrap>
            <v-tooltip top>
              <v-icon @click="editarItem(props.item)" class="mx-1" slot="activator">edit</v-icon>
              <span>Editar</span>
            </v-tooltip>

            <v-tooltip top v-if="props.item.arquivoUpload && props.item.arquivoUpload !='Não Encontrado'">
              <v-icon
                @click="aprovarHabilitacao(props.item,2)"
                class="mx-1"
                slot="activator"
                color="green"
              >spellcheck</v-icon>
              <span>Aprovar</span>
            </v-tooltip>

            <v-tooltip top v-if="props.item.arquivoUpload && props.item.arquivoUpload !='Não Encontrado'">
              <v-icon
                @click="openModalRejeitar(props.item,1)"
                class="mx-1"
                slot="activator"
                color="red accent-4"
              >highlight_off</v-icon>
              <span>Rejeitar</span>
            </v-tooltip>

            <v-tooltip top v-if="props.item.arquivoUpload && props.item.arquivoUpload !='Não Encontrado'">
              <v-icon
                @click="deleteItem(props.item)"
                class="mx-1"
                slot="activator"
              >delete</v-icon>
              <span>Deletar</span>
            </v-tooltip>
          </td>
          <td class="text-xs-left">{{ props.item.nome }}
            <div v-html="ifHabilitacaoJuridicaAlterado(props.item.cpfCnpj,props.item.nome,'nome')"></div>
            <div v-html="ifHabilitacaoJuridicaNova(props.item.cpfCnpj,'D')"></div>
          </td>
          <td class="text-xs-left" nowrap>
            <a v-show="props.item.isFuncionarioPublico">
              <v-tooltip top>
                <v-icon class="mx-1" slot="activator" :size="20" color="red">info</v-icon>
                <span>Esse CPF pertence a um Servidor Público</span>
              </v-tooltip>
            </a>
            <input
              v-if="(props.item.flagEstrangeiro) == 0"
              v-bind:class="{'cpf-servidor':props.item.isFuncionarioPublico}"
              v-mask="(props.item.tipoHabilitador =='J') ? maskCnpj : maskCpf"
              readonly
              :value="props.item.cpfCnpj"
            />
            <input
              v-else
              v-mask="maskDocumentoIdentificacao"
              readonly
              :value="props.item.cpfCnpj"
            />
          </td>
          <td class="text-xs-center">
            {{ props.item.flagEstrangeiro == "0" ? "Sim" : "Não" }}
            <div v-html="ifHabilitacaoJuridicaAlterado(props.item.cpfCnpj,props.item.flagEstrangeiro,'flagEstrangeiro')"></div>
          </td>
          <td class="text-xs-center">
            {{ props.item.cargo }}
           <div v-html="ifHabilitacaoJuridicaAlterado(props.item.cpfCnpj,props.item.cargo,'cargo')"></div>
          </td>
          <td class="text-xs-center">
            <a
              @click="baixarDocumento(props.item.arquivoUpload)"
            >{{subStrUpload(props.item.arquivoUpload,$t("label.anexo"))| truncateString(35)}}</a>
            <div v-html="ifHabilitacaoJuridicaAlterado(props.item.cpfCnpj,props.item.arquivoUpload,'arquivoUpload')"></div>
          </td>
        </tr>
      </template>
    </v-data-table>
    <dialogMotivoIndeferimento
      :config="modelDialogRejeitarDirigente"
      v-on:observacaoOk="rejeitarHabilitacao($event)"
      v-on:observacaoCancel="fnAcaoModalCancelar()"
    />
  </v-flex>
</template>



<script>
import util from "../../../../plugins/util"; /*Objeto com metodos e funcoes utilizadas pelo sistema */
import analiseCampoAlterado from "./analiseCampoAlterado";
import sociosDirigentes from "./socios-dirigentes";
import fornecedorService from "@/services/fornecedorService"; /*Objeto com os principais servicos de Fornecedor */
export default {
  name: "dirigentes-crud",
  mixins: [util, analiseCampoAlterado, sociosDirigentes],
  props: {//Propriedades que o objeto recebe como parametro
    model: Object, /*Solicitacao atual do Fornecedor*/
    habilitacaoLista: Object,
    erroHabilitacaoJuridica: Object,
    OldModel: Object
  },
  data() {//Declaracao de variaveis
    return {
      crud: false,
      totalDesserts: 0,
      loading: false,
      modelDialogRejeitarDirigente: {
        open: false,
        obs: null,
        titulo: "Motivo",
        codDocumento:0,
        motivoSelecionado:0,
        motivoSelecionado2: null,
        motivoSelecionado3: null
      },
      itemRejeitado: {},
      headers: [ /*Cabeçalho da data-table*/
        {
          text: "Ações",
          align: "center",
          sortable: false,
          width: 130
        },
        {
          text: this.$t("label.nome"),
          align: "left",
          sortable: false,
          width: 250
        },

        {
          text: this.$t("label.cpf"),
          align: "left",
          sortable: false,
          width: 130
        },
        {
          text: this.$t("label.brasileiro") + "?",
          align: "center",
          sortable: false,
          width: 70
        },
        {
          text: this.$t("label.cargo"),
          align: "center",
          sortable: false,
          width: 120
        },
        {
          text: this.$t("label.anexo"),
          align: "center",
          sortable: false,
          width: 200
        }
      ]
    };
  },
  methods: {//Declaracao de todos os metodos

    deleteItem(itemLista) {
        //apagar o dirigente
        fornecedorService
          .deleteFornecedorHabilitacaoJuridica(itemLista.idFornecHabilitacaoJur)
          .then(response => { /*resposta do servico*/
            this.model.fornecedoresHabilitacaoJuridica = response.data; /*dados de retorno*/
            this.habilitacaoLista.sociosLista = [];
            this.habilitacaoLista.dirigentesLista = [];

            this.model.fornecedoresHabilitacaoJuridica.filter(item => {
              if (item.tipoCadastro === "D") {
                this.habilitacaoLista.dirigentesLista.push(item);
              } else {
                this.habilitacaoLista.sociosLista.push(item);
              }
            });
          });
    },
    openModalRejeitar(itemLista) {
      this.itemRejeitado = itemLista;

      this.modelDialogRejeitarDirigente.open = true;
      this.modelDialogRejeitarDirigente.codDocumento = itemLista.codDocumentoSIMPAS;
      this.modelDialogRejeitarDirigente.motivoSelecionado = this.itemRejeitado.idMotivoIndeferimentoArquivo;
      this.modelDialogRejeitarDirigente.motivoSelecionado2 = this.itemRejeitado.idMotivoIndeferimentoArquivo2 || null;
      this.modelDialogRejeitarDirigente.motivoSelecionado3 = this.itemRejeitado.idMotivoIndeferimentoArquivo3 || null;
    },

    fnAcaoModalCancelar() {
      this.modelDialogRejeitarDirigente.open = false;
    }
  }
};
</script>

<style scoped> /*CSS especifico do componente*/
.v-datatable .v-tooltip {
  display: inline-flex !important;
  align-items: center;
}
</style>